// @ts-expect-error
import ga4mp from "@analytics-debugger/ga4mp";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

let ga4track: any;

type LoadGtagOptions = {
  userId?: string;
  clientId?: string;
};
export function loadGa4mp(tagId: string, options: LoadGtagOptions) {
  ga4track = ga4mp([tagId], {
    user_id: options.userId,
    client_id: options.clientId,
    non_personalized_ads: true,
    debug: false,
  });
}

export function sendGa4mpEvent(
  eventName: string,
  eventParamList: Record<string, unknown>,
) {
  if (ga4track !== undefined) {
    ga4track.trackEvent(eventName, eventParamList);
  }
}
